import React from 'react';
import ArcDropdown from '../../ArcDropdown/ArcDropdown';
import ArcTextField from '../../ArcTextField/ArcTextField';
import ArcCombo from '../../ArcCombo/ArcCombo';
import ArcFilteredCombo from '../../ArcFilteredCombo/ArcFilteredCombo';
import ArcNumber2 from '../../ArcNumber/ArcNumber2';
import EvaluateRules from '../../../../Utils/Rules/EvaluateRules';
import './FieldGridField.css';
import ArcToggle from '../../ArcToggle/ArcToggle';
import { TextField } from '@fluentui/react';

const FieldGridField = (props) => {
    const mapWidthToClass = (width) => {
        switch (width) {
            case 'narrow':
                return 'fieldgridfield-narrow';
            case 'smaller':
                return 'fieldgridfield-smaller';
            case 'small':
                return 'fieldgridfield-small';
            case 'medium':
                return 'fieldgridfield-medium';
            case 'wide':
                return 'fieldgridfield-wide';
            case 'extrawide':
                return 'fieldgridfield-extrawide';
            default:
                return 'fieldgridfield-content';
        }
    };

    const mapTypeToField = (type) => {
        switch (type) {
            case 'dropdown':
                return (
                    <ArcDropdown
                        onKeyDown={props.onKeyDown}
                        config={props.config}
                        valueChangeHandler={fieldChangeHandler}
                    ></ArcDropdown>
                );
            case 'combobox':
                return (
                    <ArcCombo
                        onKeyDown={props.onKeyDown}
                        config={props.config}
                        changeHandler={fieldChangeHandler}
                    ></ArcCombo>
                );
            case 'filteredcombo':
                return (
                    <ArcFilteredCombo
                        config={props.config}
                        changeHandler={comboBoxChangeHandler}
                    ></ArcFilteredCombo>
                );
            case 'number':
                return (
                    <ArcNumber2
                        onKeyDown={props.onKeyDown}
                        config={props.config}
                        changeHandler={fieldChangeHandler}
                    ></ArcNumber2>
                );
            case 'toggle':
                return (
                    <ArcToggle
                        onKeyDown={props.onKeyDown}
                        config={props.config}
                        valueChangeHandler={fieldChangeHandler}
                        showText={true}
                    ></ArcToggle>
                );
            case 'text':
                return (
                    <TextField
                        onKeyDown={props.onKeyDown}
                        id={props.config.Id}
                        label={props.config.Label}
                        disabled
                        value={props.config.value}
                        onChange={fieldChangeHandler}
                        readOnly={true}
                    ></TextField>
                );

            case 'hidden':
                break;
            default:
                return (
                    <ArcTextField
                        onKeyDown={props.onKeyDown}
                        config={props.config}
                        changeHandler={fieldChangeHandler}
                    ></ArcTextField>
                );
        }
    };

    const fieldChangeHandler = (_, value) => {
        props.changeHandler(props.config.Id, value);
    };

    const comboBoxChangeHandler = (_, value) => {
        if (value) props.changeHandler(props.config.Id, value.key);
    };

    const visible =
        EvaluateRules('visible', props.config.Rules, props.data) &&
        props.config.Type !== 'hidden';

    return visible ? (
        <span className={mapWidthToClass(props.config.Width)}>
            {mapTypeToField(props.config.Type)}
        </span>
    ) : null;
};

export default FieldGridField;
